import BaseContainer from '@base/BaseContainer';
import Footer from './Footer';
import Header from './Header';

export interface ILayoutProps {
    isAuth: boolean | null;
}

const DefaultLayout: React.FC<ILayoutProps> = ({ children, isAuth }) => {
    return (
        <div className="flex flex-col min-h-[100vh] bg-blueGray-100">
            <Header isAuth={isAuth} />
            {/* TODO: убрать хак, обертка в лишний див для фикса тк меняется класс на toastify */}
            <div className="flex-grow mt-4 mb-4 xs:mt-10 xs:mb-10">
                <BaseContainer>{children}</BaseContainer>
            </div>
            <Footer isAuth={isAuth} />
        </div>
    );
};

export default DefaultLayout;
